module.exports = __webpack_public_path__ + "dashboard/img/rangowane-12.3e96785ddce8362cd7c80b7c3559086e.svg";